/**
 * @Author: luoob
 * @Date: 2021-10-25 10:37:36
 * @Last Modified by: luoob
 * @Last Modified time: 2021-10-25 10:37:33
 * @Instruduction: 在线协助辅助函数
 */

import { parseTime, isHitSuffix } from '@/common/utils'
import { curry } from 'lodash'
import { IMG_HOST } from '@/config/env'
 
// 在线协助标识，在 menu 中使用
export const ONLINE_KEY = 'online'
 
// 聊天记录列表类型
export const listType = {
    chat: 'chat',           // 聊天类型
    grade: 'grade'          // 评分类型
}
 
// 评论类型
// 因为通过接口返回数据是一个数组
// 做不到隐射
export const commentTypes = {
    text: {
        value: 1,
        label: '文字'
    },
    photo: {
        value: 2,
        label: '图片'
    },
    file: {
        value: 3,
        label: '文件'
    },
    notice: {
        value: 100,
        label: '系统消息'
    },
    feedback: {
        value: 101,
        label: '反馈模块'
    }
}
 
// 评论类型
// 因为通过接口返回数据是一个数组
// 做不到隐射
export const statusTypes = {
    unassigned: { 
        value: 1, 
        label: '待分派'
    },
    processing: { 
        value: 2,
        label: '处理中'
    },
    waitFeedback: {
        value: 3,
        label: '待反馈'
    },
    closed: {
        value: 4,
        label: '已关闭'
    }
}
 
/**
  * 创建合适格式的评论
  * @date 2021-12-21
  * @param {any} comment
  * @returns {any}
  */
export const generateComment = (comment: any) => {
    const isEnd = comment.type_id === commentTypes.notice.value
    if (isEnd) {
        return comment
    }
     
    const isText = comment.type_id === commentTypes.text.value
    const isFile = [commentTypes.file.value, commentTypes.photo.value].includes(comment.type_id)
    const isFeedback = comment.type_id === commentTypes.feedback.value
 
    const getFileType = (filename: string) => {
        // 判断文件类型，进行使用不同的图标
        const isValidSuffix = (suffixs: any[], filename: string) => isHitSuffix(filename, suffixs) 
        const isPdf = curry(isValidSuffix)(['.pdf'])
        const isWord = curry(isValidSuffix)(['.doc', '.docx'])
        const isMp3 = curry(isValidSuffix)(['.mp3'])
        const isPhoto = curry(isValidSuffix)(['.jpg', '.png', '.jpeg'])
        const validators = [
            { validator: isPdf, type: 'pdf' },
            { validator: isWord, type: 'word' },
            { validator: isMp3, type: 'mp3' },
            { validator: isPhoto, type: 'photo' }
        ]
        let ctype = ''
        validators.some(({ validator, type }) => {
            if (validator(filename)) {
                ctype = type
                return true
            }
        })
        return ctype
    }
 
    let record: any = {
        type: listType.chat,
        id: comment.id,
        isSend: comment.is_sender,
        avatar: comment.user.avatar,
        label: parseTime(comment.created_at, '{y}-{m}-{d} {h}:{i}')
    }
    if (isText) {
        record.message = comment.content
    } else if (isFile) {
        record.message = comment.file_name
        record.url = IMG_HOST + comment.file_url
        record.fileType = getFileType(comment.file_name)
        record.isFile = true
    } else if (isFeedback) {
        record.type = listType.grade
        record.isSend = false
    }
 
    return record
}

// 文字记录
// {
//     type: listType.chat,
//     id: uniqueId(), 
//     isSend: true,
//     label: '2020-08-31 11:52',
//     message: '好的，很高兴能帮助到您，祝您生活愉快；欢迎您为本次服务做出评价吧。好的，很高兴能帮助到您，祝您生活愉快；欢迎您为本次服务做出评价吧。'
// },
// 文件记录
// {
//     type: listType.chat,
//     id: uniqueId(), 
//     isFile: true,
//     isSend: true,
//     fileType: 'mp3',
//     label: '2020-08-31 11:52',
//     message: '好运来.mp3'
// },
// 评价记录
// {
//     type: listType.grade,
//     isSend: false,
//     id: uniqueId(), 
//     data: ''
// }
